import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import useTranslation from "next-translate/useTranslation";
import { Price } from "@/components/PricingCard/Price";
import { LinkButton } from "@/components/LinkButton";
import { CALENDLY_LINK_PRODUCT_DEMO } from "@/constants/pricing";
import { Image } from "@/components/Image";
import { IPricingCard } from "../types";

export const EnterprisePricingSectionItem: React.FC<IPricingCard> = ({
  image,
  name,
  startingAt,
  price,
  text,
}) => {
  const { t } = useTranslation();
  const { css } = useFela();
  const { bp, colors } = useTheme();

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        flexBasis: "50%",
        padding: "0px 40px",
        color: colors.WHITE,
        nested: {
          ":last-child": {
            paddingTop: 30,
            [bp.FROM_TABLET]: {
              padding: "0 40px",
            },
          },
          ":not(:last-child)": {
            borderBottom: "2px solid #442F84",
            padding: "30px 0",
            [bp.FROM_TABLET]: {
              padding: "0 40px",
              borderBottom: "none",
              borderRight: "2px solid #442F84",
            },
          },
        },
      })}
    >
      <Image
        {...image}
        customStyle={{ maxHeight: 80, margin: "0 auto 24px" }}
      />
      <Heading
        as="h2"
        customStyle={{
          marginBottom: 8,
          textAlign: "center",
          color: colors.WHITE,
        }}
      >
        {name}
      </Heading>
      <p
        className={css({
          fontSize: 14,
          lineHeight: "22px",
          textAlign: "center",
          margin: "-10px auto 8px",
          opacity: 0.7,
        })}
      >
        {startingAt}
      </p>
      <Price
        value={price}
        suffix="month"
        customStyle={{
          textAlign: "center",
          nested: {
            "> strong": {
              fontSize: 36,
              lineHeight: "46px",
            },
            "> span:first-child": {
              fontSize: 36,
              lineHeight: "46px",
              fontWeight: 700,
            },
            "> span:last-child": {
              opacity: 0.7,
            },
            "> span:last-child span": {
              display: "inline-block",
              marginRight: 2,
              opacity: 0.7,
            },
          },
        }}
      />
      <p
        className={css({
          marginTop: 16,
          fontSize: 18,
          lineHeight: "28px",
          letterSpacing: "0.5px",
          textAlign: "center",
          opacity: 0.8,
        })}
      >
        {text}
      </p>
      <LinkButton
        href={CALENDLY_LINK_PRODUCT_DEMO}
        target="_blank"
        customStyle={{ maxWidth: 190, margin: "24px auto 8px" }}
        title={t("common:requestDemo")}
      />
      <a
        href="/pricing"
        className={css({
          fontSize: 14,
          lineHeight: "24px",
          margin: "auto",
          color: "#E5EAF4",
        })}
      >
        See smaller pricing options
      </a>
    </div>
  );
};
